import React from 'react';
import styles from './index.module.less';

export function Voucher(props) {
    return <>voucher</>
}